import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        classifiers: '=',
        sites: '='
    },
    template: `
        <div class="col00">
            <div class="heading01 type01">
                <h1>{{ 'report.Courses' | translate }}</h1>
            </div>
            <reports-courses-filter default-filter="vm.defaultFilter" fields="vm.fields" departments="vm.departments" roles="vm.roles" levels="vm.levels"
                last-query="vm.lastQuery" query="vm.query" classifiers="vm.classifiers" list="vm.list" sites="vm.sites"></reports-courses-filter>
            <div class="well">
                <div class="heading01">
                    <h2>{{ 'report.Report' | translate }}</h2>
                    <ul class="actions01">
                        <li><a ng-click="vm.exportCsv()" class="btn ico-download">{{ 'report.Export as csv' | translate }}</a></li>
                    </ul>
                </div>
                <ul class="metablock">
                    <li ng-if="vm.lastQuery.name">
                        <div class="label">{{ 'report.Name' | translate }}</div>
                        <div class="value">{{ vm.lastQuery.name }}</div>
                    </li>
                    <li ng-if="vm.lastQuery.fieldId">
                        <div class="label">{{ 'report.Field' | translate }}</div>
                        <div class="value">{{ vm.getClassifier(vm.lastQuery.fieldId, vm.fields) }}</div>
                    </li>
                    <li ng-if="vm.lastQuery.departmentId">
                        <div class="label">{{ 'report.Department' | translate }}</div>
                        <div class="value">{{ vm.getClassifier(vm.lastQuery.departmentId, vm.departments) }}</div>
                    </li>
                    <li ng-if="vm.lastQuery.roleId">
                        <div class="label">{{ 'report.Role' | translate }}</div>
                        <div class="value">{{ vm.getClassifier(vm.lastQuery.roleId, vm.roles) }}</div>
                    </li>
                    <li ng-if="vm.lastQuery.levelId">
                        <div class="label">{{ 'report.Level' | translate }}</div>
                        <div class="value">{{ vm.getClassifier(vm.lastQuery.levelId, vm.levels) }}</div>
                    </li>
                </ul>
                <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
                <div class="well">
                    <table datatable dt-options="vm.DATATABLES" ng-if="!vm.list.loading && vm.list.items.length" class="data01">
                        <thead>
                            <tr>
                                <th>{{ 'report.Course name' | translate }}</th>
                                <th>{{ 'report.Field' | translate }}</th>
                                <th>{{ 'report.Course target' | translate }}</th>
                                <th ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()">{{ 'report.Need Type' | translate }}</th>
                                <th>{{ 'report.Targeted employees' | translate }}</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr ng-repeat="course in vm.list.items">
                                <td ng-if="vm.TokenService.isCompanyMagnum()">{{ course.sop }} {{ course.activeI18n.name }}</td>
                                <td ng-if="!vm.TokenService.isCompanyMagnum()">{{ course.activeI18n.name }}</td>
                                <td>{{ vm.CourseService.getFieldNames(course, vm.fields) }}</td>
                                <td>
                                    <p ng-repeat="drl in course.courseTargetsWithValue">{{ vm.getDrlSetLabel(drl) }}</p>
                                </td>
                                <td ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()">
                                    <p ng-repeat="drl in course.courseTargetsWithValue">{{ vm.getDrlSetNeedType(drl) }}</p>
                                </td>
                                <td ng-if="!vm.defaultFilter.includeOptionalTargets">{{ course.targetedEmployees }}</td>
                                <td ng-if="vm.defaultFilter.includeOptionalTargets">{{ course.targetedEmployeesWithOptional }}</td>
                                <td class="actions">
                                    <p class="hidden course-id">{{ course.id }}</p>
                                    <a ng-click="vm.viewTargets(course.id)" class="btn view">{{ 'report.View employees' | translate }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination list="vm.list"></pagination>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($window, $scope, $translate, lodash, DtTableFactory, CLASSIFIER_ENUM, COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM, COURSE_TARGET_NEED_TYPE_ENUM,
                 ListFactory, CourseResource, AuthResource, ModalService, TokenService, ReportService, CourseService) {
        this.$window = $window;
        this.$translate = $translate;
        this.lodash = lodash;
        this.ListFactory = ListFactory;
        this.ModalService = ModalService;
        this.TokenService = TokenService;
        this.ReportService = ReportService;
        this.AuthResource = AuthResource;
        this.CourseResource = CourseResource;
        this.CourseService = CourseService;
        this.DATATABLES = DtTableFactory.createExtendableTableOptionsForCourseReport($scope);
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM = COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
    }

    $onInit () {
        this.defaultFilter = { expand: 'courseTargetsWithValue.employee,fields,activeI18n', includeOptionalTargets: true };
        this.lastQuery = {};
        this.query = {};
        this.list = this.ListFactory.createWithPagination(this.CourseResource.targetsReport.bind(this.CourseResource));
        this.list.fetch(this.defaultFilter);
        this.fields = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.FIELD);
        this.departments = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);
        this.allDepartmentsLabel = this.$translate.instant('course.All departments');
        this.allRolesLabel = this.$translate.instant('course.All roles');
        this.allLevelsLabel = this.$translate.instant('course.All levels');
    }

    getDrlSetLabel (drlSet) {
        if (!drlSet.employee) {
            return [
                drlSet.departmentName ? drlSet.departmentName : this.allDepartmentsLabel,
                drlSet.roleName ? drlSet.roleName : this.allRolesLabel,
                drlSet.levelName ? drlSet.levelName : this.allLevelsLabel
            ].join(', ');
        }
        return drlSet.employee.displayName;
    }

    getDrlSetNeedType (drlSet) {
        if (!drlSet.employee) {
            return this.COURSE_TARGET_NEED_TYPE_ENUM.LABELS[drlSet.type];
        }
        return this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM.LABELS[drlSet.type];
    }

    viewTargets (courseId) {
        const { defaultFilter } = this;
        return this.ModalService.open({
            template: '<modals-planning-needs-deadline course-id="vm.courseId" class="wrapper" filter="vm.filter" cancel="vm.$uibModalInstance.dismiss()" update="vm.update()"/>',
            controller ($uibModalInstance) {
                this.courseId = courseId;
                this.filter = { isOptionalTargetsIncluded: defaultFilter.includeOptionalTargets };
                this.$uibModalInstance = $uibModalInstance;
                this.update = () => {
                    this.$uibModalInstance.close();
                };
            },
            size: 'xlarge'
        });
    }

    exportCsv () {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const qs = this.ReportService.buildQueryString(this.lastQuery);
                const lang = this.TokenService.getActiveLanguage(true);
                const url = `${SEED_CORE.ENV.API_URL}course/course/targets-report-export?tacToken=${token}&${qs}&_lang=${lang}&includeOptionalTargets=${this.defaultFilter.includeOptionalTargets}`;
                this.$window.open(url);
            });
    }

    getClassifier (id, classifiers) {
        const classifierResult = classifiers.filter((classifier) => classifier.id === id);
        return classifierResult[0].value;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/courses/index.js